import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmContactUs = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: 'async-contact-us' */ './csm-contact-us')),
});
